import WithRender from "../../templates/ui/quantitySelection.html";
import { i18n } from "../../i18n.js";

import { mapGetters, mapActions } from "vuex";
import Select2 from "v-select2-component";

export default WithRender({
  components: { Select2 },
  computed: {
    ...mapGetters([
      "getQuantitySelection",
      "getPersonalizationCustomPrices",
      "getPersonalizationQuantityWithPrice",
      "getHideSearchBoxInPoptext",
      "getQuantityField"
    ]),
    value: {
      get: function () {
        return this.getQuantityField;
      },
      set: function (newValue) {
        this.setQuantityField(newValue);
      }
    },
    name: () => {
      return i18n.t("Fixed quantities");
    },
    settings: function () {
      var hideOptions = {};
      if (this.getHideSearchBoxInPoptext) {
        hideOptions = { minimumResultsForSearch: -1 };
      }
      return { ...hideOptions };
    },
    getQuantities: function () {
      var qties = this.getQuantitySelection.split(",");
      var pcsString = i18n.t("Pcs.");
      var prices = [];
      if (this.getPersonalizationQuantityWithPrice) {
        prices = this.getPersonalizationCustomPrices;
      }
      return qties.map(el => {
        var text = el + " " + pcsString;
        if (this.getPersonalizationQuantityWithPrice) {
          text = el + " " + pcsString + " - " + i18n.n(prices[el], "currency");
        }
        return {
          text,
          id: el
        };
      });
    }
  },
  methods: {
    ...mapActions(["setQuantityField"])
  }
});
